export default {
  state: {
    villageList: JSON.parse(window.sessionStorage.getItem('villageList')),
    arrangeVillageList: JSON.parse(window.sessionStorage.getItem('arrangeVillageList')),
    adminList: []
  },
  mutations: {
    setVillage(state, village_list) {
      state.villageList = village_list;
      window.sessionStorage.setItem('villageList', JSON.stringify(village_list))
    },
    setArrangeVillage(state, arrange_village) {
      state.arrangeVillageList = arrange_village;
      window.sessionStorage.setItem('arrangeVillageList', JSON.stringify(arrange_village))
    },
    setAdmin(state, admin_list) {
      state.adminList = admin_list
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/village_store.js